/* eslint-disable padded-blocks */
/* This mixin contains the sketch helper functions for the Project Map object */

export default {
  methods: {
    highlightProjectSites() {
      if (this.projectSites && this.projectSites.length > 0) {
        const layer = this.siteLayer;
        this.view.whenLayerView(layer).then((layerView) => {
          const insightlyIds = this.projectSites.map((projectSite) => `'${projectSite.relatedSiteId}'`).join(', ');
          const query = layer.createQuery();
          query.where = `insightlyid IN (${insightlyIds})`;
          layer.queryFeatures(query).then(async (results) => {
            results.features.forEach((feature) => {
              this.selectedSites.push({
                graphic: feature,
                highlight: layerView.highlight(feature),
              });
            });
          });
        });
      }
    },
    unhighlightProjectSites() {
      this.selectedSites.forEach((site) => site.highlight.remove());
    },
  },
};
